<template>
  <div v-if="domiciliationBancaire">
    <div class="entete border-entete">
      <div class="level">
        <div class="level-left">
          <div class="columns is-gapless">
            <div class="column">
              <h1 class="title is-size-3">{{ domiciliationBancaire.libelle }}</h1>
              <app-breadcrumb :breadcrumb="breadcrumb" />
            </div>
          </div>
        </div>
        <div class="level-right">
          <div class="is-pulled-right buttons boutonAction">
            <a class="button is-addOrEdit"
               :class="{
                   'button-access-no-permission' : !checkPermissions(permsDomiciliationBancaire.maj)
                   }"
               @click="$router.push({ name: 'm.parametrage.domiciliation_bancaire-edit',
               params: { id: $route.params.id } })">
              {{ $t('detailDomiciliationBancaire.actions.edit') }}
            </a>
          </div>
        </div>
      </div>
    </div>
    <div class="columns is-multiline mgt-20px">
      <div class="column is-12">
        <div class="card">
          <header class="header-card">
            <p>
              {{$t('detailDomiciliationBancaire.title')}}
            </p>
          </header>
          <div class="card-content">
            <div class="columns is-multiline mgb-10px">
              <div class="column is-6">
                <p class="has-text-weight-bold has-text-link is-size-4">
                  {{ domiciliationBancaire.libelle }}
                </p>
              </div>
              <div class="column is-6">
                <p class="has-text-weight-bold has-text-link is-size-4">
                  {{ domiciliationBancaire.libelleBanque }}
                </p>
              </div>
              <div class="column is-6 has-background-background editFieldLabelDomiciliation">
                <b-field class="mgl-10px mgt-10px">
                  <span class="has-text-link has-text-weight-bold mgr-5px">
                    {{$t('detailDomiciliationBancaire.titulaire')}}
                  </span>
                  {{ domiciliationBancaire.titulaire }}
                </b-field>
                <b-field horizontal class="column is-12 iban"
                         custom-class="has-text-link has-text-left mgt-5px"
                         :label="$t('detailDomiciliationBancaire.iban')">
                  <p class="has-background-white pd-10px">
                    {{ iban }}</p>
                </b-field>
                <b-field horizontal class="column is-12 bic"
                         custom-class="has-text-link has-text-left mgt-5px"
                         :label="$t('detailDomiciliationBancaire.bic')">
                  <p class="has-background-white pd-10px">
                    {{ domiciliationBancaire.codeSwift }}</p>
                </b-field>
                <b-field  class="column is-12"
                         custom-class="has-text-link mgt-30px has-text-left"
                         :label="$t('detailDomiciliationBancaire.rib')">
                  <b-field :label="$t('detailDomiciliationBancaire.codeBanque')"
                           custom-class="has-text-default is-italic
                           has-text-weight-light mgl-30px">
                    <p class="has-background-white pd-10px mgl-30px">
                    {{ domiciliationBancaire.codeBanque }}</p>
                  </b-field>
                  <b-field :label="$t('detailDomiciliationBancaire.codeAgence')"
                           custom-class="has-text-default is-italic
                           has-text-weight-light mgl-20px">
                    <p class="has-background-white pd-10px mgl-20px">
                    {{ domiciliationBancaire.codeGuichet }}</p>
                  </b-field>
                  <b-field :label="$t('detailDomiciliationBancaire.numeroCompte')"
                           custom-class="has-text-default is-italic
                           has-text-weight-light mgl-20px">
                    <p class="has-background-white pd-10px mgl-20px">
                    {{ domiciliationBancaire.numeroCompte }}</p>
                  </b-field>
                  <b-field :label="$t('detailDomiciliationBancaire.cleRib')"
                           custom-class="has-text-default is-italic
                           has-text-weight-light mgl-20px">
                    <p class="has-background-white pd-10px mgl-20px">
                    {{ domiciliationBancaire.cleRib }}</p>
                  </b-field>
                </b-field>
              </div>
              <div class="column is-6">
                <b-field>
                  <b-field :label="$t('detailDomiciliationBancaire.compteComptable')"
                           class="column is-4 pdt-0"
                           custom-class="has-text-default is-italic has-text-weight-light">
                    <span class="has-text-weight-bold">{{ domiciliationBancaire.numCpta }}</span>
                  </b-field>
                  <b-field :label="$t('detailDomiciliationBancaire.compteEscompte')"
                           class="column is-4 pdt-0"
                           custom-class="has-text-default is-italic has-text-weight-light">
                    <span class="has-text-weight-bold">
                    {{ domiciliationBancaire.compteEscompte }}
                    </span>
                  </b-field>
                </b-field>
                <b-field>
                  <b-field :label="$t('detailDomiciliationBancaire.codeJournal')"
                           class="column is-4 pdt-0"
                           custom-class="has-text-default is-italic has-text-weight-light">
                    <span class="has-text-weight-bold">
                    {{ domiciliationBancaire.codeJournal }}
                    </span>
                  </b-field>
                  <b-field :label="$t('detailDomiciliationBancaire.tvaSurEscompte')"
                           class="column is-4 pdt-0"
                           custom-class="has-text-default is-italic has-text-weight-light">
                    <span class="has-text-weight-bold">
                    {{ domiciliationBancaire.compteEscompteTva }}
                    </span>
                  </b-field>
                </b-field>
                <b-field>
                  <b-field :label="$t('detailDomiciliationBancaire.actif')"
                           class="column is-4 pdt-0"
                           custom-class="has-text-default is-italic has-text-weight-light">
                    <span class="has-text-weight-bold">
                    {{ domiciliationBancaire.actif ? $t('general.oui') :  $t('general.non') }}
                    </span>
                  </b-field>
                  <b-field :label="$t('detailDomiciliationBancaire.interfaceComptable')"
                           class="column is-4 pdt-0"
                           custom-class="has-text-default is-italic has-text-weight-light">
                    <span class="has-text-weight-bold">
                    {{ domiciliationBancaire.interfaceComptable ?
                    $t('general.oui') :  $t('general.non') }}
                    </span>
                  </b-field>
                  <b-field :label="$t('detailDomiciliationBancaire.SEPA')"
                           class="column is-4 pdt-0"
                           custom-class="has-text-default is-italic has-text-weight-light">
                    <span class="has-text-weight-bold">
                      {{ domiciliationBancaire.ribSepaId }}
                    </span>
                  </b-field>
                </b-field>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="column is-12">
        <div class="card">
          <header class="header-card">
            <p>
              {{$t('detailDomiciliationBancaire.parametrageLibelle.vente.title')}}
            </p>
          </header>
          <div class="card-content">
            <div class="columns is-multiline">
              <b-field
                :label="$t('detailDomiciliationBancaire.parametrageLibelle.vente.ecriture')"
                       class="column"
                       custom-class="has-text-default is-italic has-text-weight-light">
                <span class="has-text-weight-bold">
                  {{ domiciliationBancaire.libelleEcritureReglement }}
                </span>
              </b-field>
              <b-field
                :label="$t('detailDomiciliationBancaire.parametrageLibelle.vente.ecritureTiers')"
                       class="column"
                       custom-class="has-text-default is-italic has-text-weight-light">
                <span class="has-text-weight-bold">
                  {{ domiciliationBancaire.libelleLigneEcritureReglementTiers }}
                </span>
              </b-field>
              <b-field :label="$t('detailDomiciliationBancaire.' +
               'parametrageLibelle.vente.ecritureBanque')"
                       class="column"
                       custom-class="has-text-default is-italic has-text-weight-light">
                <span class="has-text-weight-bold">
                  {{ domiciliationBancaire.libelleLigneEcritureReglementBanque }}
                </span>
              </b-field>
              <b-field
                :label="$t('detailDomiciliationBancaire.parametrageLibelle.vente.referenceTiers')"
                class="column"
                custom-class="has-text-default is-italic has-text-weight-light">
                <span class="has-text-weight-bold">
                  {{ domiciliationBancaire.libelleReferenceReglementTiers }}
                </span>
              </b-field>
              <b-field
                :label="$t('detailDomiciliationBancaire.parametrageLibelle.vente.referenceBanque')"
                class="column"
                custom-class="has-text-default is-italic has-text-weight-light">
                <span class="has-text-weight-bold">
                  {{ domiciliationBancaire.libelleReferenceReglementBanque }}
                </span>
              </b-field>
            </div>
          </div>
        </div>
      </div>
      <div class="column is-12">
        <div class="card">
          <header class="header-card">
            <p>
              {{$t('detailDomiciliationBancaire.parametrageLibelle.achat.title')}}
            </p>
          </header>
          <div class="card-content">
            <div class="columns is-multiline">
              <b-field
                :label="$t('detailDomiciliationBancaire.parametrageLibelle.achat.ecriture')"
                class="column"
                custom-class="has-text-default is-italic has-text-weight-light">
                <span class="has-text-weight-bold">
                  {{ domiciliationBancaire.libelleEcriturePaiement }}
                </span>
              </b-field>
              <b-field
                :label="$t('detailDomiciliationBancaire.parametrageLibelle.achat.ecritureTiers')"
                class="column"
                custom-class="has-text-default is-italic has-text-weight-light">
                <span class="has-text-weight-bold">
                  {{ domiciliationBancaire.libelleLigneEcriturePaiementTiers }}
                </span>
              </b-field>
              <b-field :label="$t('detailDomiciliationBancaire.' +
               'parametrageLibelle.achat.ecritureBanque')"
                       class="column"
                       custom-class="has-text-default is-italic has-text-weight-light">
                <span class="has-text-weight-bold">
                  {{ domiciliationBancaire.libelleLigneEcriturePaiementBanque }}
                </span>
              </b-field>
              <b-field
                :label="$t('detailDomiciliationBancaire.parametrageLibelle.achat.referenceTiers')"
                class="column"
                custom-class="has-text-default is-italic has-text-weight-light">
                <span class="has-text-weight-bold">
                  {{ domiciliationBancaire.libelleReferencePaiementTiers }}
                </span>
              </b-field>
              <b-field
                :label="$t('detailDomiciliationBancaire.parametrageLibelle.achat.referenceBanque')"
                class="column"
                custom-class="has-text-default is-italic has-text-weight-light">
                <span class="has-text-weight-bold">
                  {{ domiciliationBancaire.libelleReferencePaiementBanque }}
                </span>
              </b-field>
            </div>
          </div>
        </div>
      </div>
      <div class="column is-12">
        <dom-bancaire-reglement :domiciliation-bancaire="domiciliationBancaire">
        </dom-bancaire-reglement>
      </div>
      <div class="column is-12">
        <positionnement-cheque :positionnement = "domiciliationBancaire.positionnement"
          :disabled="true">
        </positionnement-cheque>
      </div>
    </div>
  </div>
</template>

<script>

import { createNamespacedHelpers } from 'vuex';
import { get } from '@/api/domiciliationBancaire/index';
import messageErreur from '@/services/general/messageErreur';
import breadcrumb from '@/components/general/breadcrumb';
import { DOMICILIATIONS_BANCAIRES } from '@/configuration/general/permissionsParametrageConf';
import domBancaireReglement from '@/components/parametrage/domiciliationBancaire/detail/domBancaireReglement';
import positionnementCheque from '@/components/parametrage/domiciliationBancaire/addEdit/positionnementCheque';
import ibanFormater from '@/services/general/ibanFormater';

const permissions = createNamespacedHelpers('permissions');

export default {
  data() {
    return {
      domiciliationBancaire: null,
      permsDomiciliationBancaire: DOMICILIATIONS_BANCAIRES,
    };
  },
  components: {
    appBreadcrumb: breadcrumb,
    domBancaireReglement,
    positionnementCheque,
  },
  computed: {
    breadcrumb() {
      return [
        { title: this.$t('parametrage.racine'), route: this.$PAGE_DEFAULT, isActive: false },
        { title: this.$t('parametrage.title'), route: { name: 'l.parametrage.general' }, isActive: false },
        { title: this.$t('listeDomiciliationBancaire.title'), route: { name: 'l.parametrage.domiciliation_bancaire' }, isActive: false },
        { title: this.domiciliationBancaire.libelle, route: { name: '' }, isActive: true },
      ];
    },
    iban() {
      return ibanFormater(this.domiciliationBancaire.iban);
    },
    ...permissions.mapGetters({
      checkPermissions: 'checkPermissions',
    }),
  },
  async mounted() {
    const loadingComponent = this.$buefy.loading.open();
    try {
      this.domiciliationBancaire = (await get(this.$route.params.id)).data.result;
      this.setInformationPage(this.$t('pageGeneral.detail', { item: this.domiciliationBancaire.libelle }));
      loadingComponent.close();
    } catch (e) {
      messageErreur(this.$i18n);
      loadingComponent.close();
      throw e;
    }
  },
};
</script>
